import { VideoLink } from "../types"
import { collection, get, all, update, query, where } from "typesaurus"

export interface LessonType {
  id: string
  index?: number
  created: number
  courseId: string
  description: string
  displayName: string
  interactionBank: string
  itemBank: string
  sectionId: string
  subcourseId: string
  lastModified: number
  licenses: any[]
  name: string
  node: string[]
  published: boolean
  rules: string[]
  videoLinks: VideoLink[]
}

//TODO
export interface LessonItem {
  complete: boolean
  attempted: boolean
  correct: boolean
  createdDate: number
  code: string
  created: number
  updatedDate: number
  passage: string
  node: string
  authorId: string
  tags: string[]
  answerChoices: { [key: string]: string }
  itemType: string
  errorPenalty: number
  pairs: string[]
  question: string
  feedback: {
    correct: string
    incorrect: string
  }
  lastModified: number
  correctAnswers: string[]
  hints: string[]
  correctReward: number
  id: string
  score: number
  responses: string[]
}
export interface LessonItemBank {
  courseId: string
  created: number
  createdDate: number
  id: string
  items: { [key: string]: number | string }
  lastModified: number
  sectionId: string
  subcourseId: string
  updatedDate: number
}
export interface LessonItemBanks {
  [key: string]: LessonItemBank
}

export interface LessonTypeExtended extends LessonType {
  index: number
  allotedTime: number | string
}

const collection_ref = collection<LessonType>("lessons")

export const getLessonById = (id: string) => {
  return get(collection_ref, id)
}

export const getLessonByName = (name: string) => {
  return query(collection_ref, [where("name", "==", name)])
}

export const getLessonByCourseId = (courseId: string) => {
  return query(collection_ref, [where("courseId", "==", courseId)])
}

export const getLessonBySubCourseId = (subcourseId: string) => {
  return query(collection_ref, [where("subcourseId", "==", subcourseId)])
}

export const getAllLessons = () => {
  return all(collection_ref)
}

export const updateLessonById = (id: string, newVals: Partial<LessonType>) => {
  return update(collection_ref, id, newVals)
}
